import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { FieldType } from '@common/entities';

export const DeleteConfirmationMessage = ({ questions, questionToDelete, dependentQuestions }) => {
  const itemToDelete = questions.find((q) => q.id === questionToDelete);
  const isStaticText = itemToDelete?.type === FieldType.StaticText;

  if (isStaticText) {
    return (
      <Box>
        <Text mb={2}>Are you sure you want to delete this message?</Text>
      </Box>
    );
  }

  const questionNumber =
    questions
      .filter((q) => !q.type.includes(FieldType.StaticText))
      .findIndex((qst) => qst.id === questionToDelete) + 1;

  return (
    <Box>
      <Text mb={2}>Are you sure you want to delete Question {questionNumber}?</Text>
      {dependentQuestions.length > 0 && (
        <>
          <Text mb={2}>This will remove Question {questionNumber} as the next step in:</Text>
          {dependentQuestions.map((el) => {
            const depQuestionNumber =
              questions
                .filter((q) => !q.type.includes(FieldType.StaticText))
                .findIndex((qst) => qst.id === el.id) + 1;
            return (
              <Text key={el.id} ml={4}>
                Qualifying Question {depQuestionNumber}
              </Text>
            );
          })}
        </>
      )}
    </Box>
  );
};
